import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

export { GET_EDIT_ASSIGNMENT_CONFIG_USE_CASE } from '../get-by-id/get-assignment-by-id.usecase';
import { BadInputError, UseCase } from '@digibricks/core';
import { AssignmentType } from '../../../domain';
export var UPDATE_ASSIGNMENT_CONFIG_USE_CASE = 'UPDATE_ASSIGNMENT_CONFIG_USE_CASE';
export var UpdateAssignmentConfigUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(UpdateAssignmentConfigUseCase, _UseCase);

  var _super = _createSuper(UpdateAssignmentConfigUseCase);

  function UpdateAssignmentConfigUseCase(practice, examination) {
    var _this;

    _classCallCheck(this, UpdateAssignmentConfigUseCase);

    _this = _super.call(this);
    _this.practice = practice;
    _this.examination = examination;
    return _this;
  }

  _createClass(UpdateAssignmentConfigUseCase, [{
    key: "buildUseCase",
    value: function buildUseCase(_ref) {
      var id = _ref.id,
          type = _ref.type,
          input = _ref.input;
      if (!id || !Number.isInteger(input.expectedVersion)) return Promise.resolve(new BadInputError('Invalid assignment configuration request'));
      if (type === AssignmentType.Practice) return this.practice.updateConfig(id, input);
      if (type === AssignmentType.Examination) return this.examination.updateConfig(id, input);
      return Promise.resolve(new BadInputError('Unsupported assignment type'));
    }
  }]);

  return UpdateAssignmentConfigUseCase;
}(UseCase);